module.exports = __webpack_public_path__ + "static/Live-b9c1a14f4fd1ae75f07185a3292c467b.png";